export interface ResUsuario {
  resultado: Usuario[];
}

export interface Usuario {
  token: AccessToken;
  usuw_id: number;
  cli_id: number;
  usuario: string;
  fcm_token: null;
  latlon: null;
  codigo: string;
  sucursal: null;
  razon_social: string;
  dir_etiqueta: string;
  nombre_comercial: string;
  alm_id: number;
  alm_codigo: string;
  alm_titulo: string;
  timp_titulo: string;
  tarc_id: number;
  tipo_iva: string;
  pedcc_id: number;
  pedcc_lista_id: number;
  clave_caducada: number;
  usu_estado: string;
  parametros: string;
  parametrosMap: Map<string, any>;
  pedido_minimo: number;
  pedido_maximo: number;
  ped_min_portes: number;
  dias_servicio: number;
  imp_portes: number;
  impuestos: boolean;
  portes: boolean;
  fecha_servicio: boolean;
  precio_caja: boolean;
  hora_corte: string;
  stock: string;
  tbulto_ver: string;
  tbulto_def: string;
  pedcc_pedido: string;
  pedcc_fecha: Date;
  pedcc_referencia: Number;
  pedcc_importe: Number;
  permite_unid: string;
  pago_online: string;
  links: Link[];
}

export function jsonMapReplacer(this: any, key: string | number, value: any) {
  const originalObject = this[key];
  if (originalObject instanceof Map) {
    return {
      dataType: 'Map',
      value: Array.from(originalObject.entries()), // or with spread: value: [...originalObject]
    };
  } else {
    return value;
  }
}
export function jsonMapReviver(value: any) {
  if (typeof value === 'object' && value !== null) {
    if (value.dataType === 'Map') {
      return new Map(value.value);
    }
  }
  return value;
}
export interface AccessToken {
  access_token: string;
  expires_in: number;
  token_type: string;
}

export interface Link {
  rel: string;
  href: string;
}

export interface UsuarioBloqueo {
  usuw_id: number;
  usuario: string;
  cli_estado: string;
  usu_estado: string;
  clave: string | Int32Array;
  clave_caducada: number;
}

export interface UsuarioErrorAuth {
  error: string;
  error_description: string;
}
export interface UsuarioAuth {
  access_token: string;
  expires_in: number;
  refresh_token: string;
  refresh_expires_in: number;
  token_type: string;
  session_state: string;
  scope: string;
}
